import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';

function renderCreateDate(value) {
  if (!value) {
    return '';
  }
  return moment(value).format('DD/MM/YYYY HH:mm');
}

function renderObservations(text) {
  if (!text) {
    return '';
  }
  return (
    <Tooltip title={text} placement="topLeft">
      <span>{text}</span>
    </Tooltip>
  );
}

function buildOccurrenceManagementColumns() {
  return [
    {
      title: 'Data/hora do registro',
      dataIndex: 'createDate',
      width: 170,
      render: renderCreateDate,
    },
    {
      title: 'Tipo de ocorrência',
      dataIndex: 'occurrenceTypeName',
      width: 160,
    },
    {
      title: 'Ocorrência',
      dataIndex: 'occurrenceName',
      width: 180,
    },
    {
      title: 'Observações',
      dataIndex: 'description',
      ellipsis: true,
      width: 240,
      render: renderObservations,
    },
    {
      title: 'Título do treinamento',
      dataIndex: 'cardTitle',
      width: 220,
      ellipsis: true,
    },
    {
      title: 'Produto',
      dataIndex: 'productName',
      width: 180,
      ellipsis: true,
    },
    {
      title: 'ID do negócio',
      dataIndex: 'dealId',
      width: 130,
    },
    {
      title: 'Cliente',
      dataIndex: 'dealClient',
      width: 220,
      ellipsis: true,
    },
    {
      title: 'Registrado por',
      dataIndex: 'userName',
      width: 160,
    },
  ];
}

export default buildOccurrenceManagementColumns;
